import React from 'react';
import { useAppStore } from '../../../store/useAppStore';
import { ToastComponent } from './Toast';
import { VELLUM as T } from '../folio/kit';

/* Where notices are posted.

   THE HEADER IS STICKY AT z-index 50 AND THE STACK MUST CLEAR IT, TWICE
   OVER. It sat at top-4 (16px) with z-50: 16px from the viewport top is
   inside the header's own band, and at an equal z-index the header wins on
   document order, because it is mounted inside the router while this stack
   is a sibling of it in App. So a notice was drawn underneath the
   navigation and the first line of it could not be read at all.

   Both halves are fixed here: the stack is raised above the header, and it
   is hung below it as well. Clearing it by z-index alone would only have
   traded a hidden notice for one covering the navigation. 88px clears the
   tallest state of the header - 18px padding, a ~40px row, 18px padding and
   its 1.5px rule - with room to spare on the shorter mobile bar. */
const HEADER_CLEARANCE = 88;

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useAppStore();

  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: HEADER_CLEARANCE,
        right: 20,
        zIndex: 60,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        maxWidth: 'calc(100vw - 40px)',
        /* The stack is not a target itself - only the notices in it are, so
           it cannot swallow clicks on the page behind it. */
        pointerEvents: 'none',
      }}
    >
      {toasts.map((toast) => (
        <div key={toast.id} style={{ pointerEvents: 'auto' }}>
          <ToastComponent toast={toast} onRemove={removeToast} />
        </div>
      ))}

      <style>{`
        .fo-toast { transition: opacity 260ms ease, transform 260ms cubic-bezier(0.16, 1, 0.3, 1); }
        .fo-toast-x:hover { color: ${T.accent}; }
        .fo-toast-x:focus-visible { outline: 2px solid ${T.accent}; outline-offset: 2px; }

        @media (prefers-reduced-motion: reduce) {
          .fo-toast { transition: opacity 120ms linear; transform: none !important; }
        }

        @media (max-width: 560px) {
          .fo-toast { width: 100% !important; }
        }
      `}</style>
    </div>
  );
};

export default ToastContainer;
